module.exports = __webpack_public_path__ + "static/media/loading_icon.e5e97eca.svg";